<!-- TEMPLATE -->
<template>
  <!-- Navbar -->

  <nav
    class="navbar"
    :class="[
      { 'navbar-expand-lg': expand },
      { [`navbar-${effect}`]: effect },
      { 'navbar-transparent': !isMobile },
      { [`bg-${type}`]: type },
      { rounded: round },
    ]"
    style="top: 0px"
  >
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div class="navbar-toggle d-inline">
          <button
            type="button"
            class="navbar-toggler"
            v-on:click="toggleSidebar()"
          >
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </button>
        </div>
        <img src="@/assets/img/logo.png" width="33" />
        <a class="navbar-brand" style="color: white">PHINIX</a>
      </div>

      <navbar-toggle-button
        :toggled="toggled"
        :target="contentId"
        @click.native.stop="toggled = !toggled"
      >
      </navbar-toggle-button>

      <div
        class="collapse navbar-collapse"
        :class="{ show: toggled }"
        :id="contentId"
        v-click-outside="closeMenu"
      >
        <ul class="navbar-nav ml-auto">
          <NotificationsList :ismobile="isMobile" />

          <li
            class="dropdown nav-item"
            v-bind:class="{ show: showProfile }"
            v-on:click="showProfile = !showProfile"
          >
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <a
                  href="#"
                  class="dropdown-toggle nav-link"
                  data-toggle="dropdown"
                  v-on="on"
                >
                  <p v-if="!isMobile">
                    <v-icon dark>mdi-account-outline</v-icon>
                  </p>
                  <p v-if="isMobile">
                    <v-icon light>mdi-account-outline</v-icon>
                    Profile
                  </p>
                  <b class="caret d-none d-lg-block d-xl-block"></b>
                </a>
              </template>
              <v-list dense>
                <v-list-item @click="" to="/settings">
                  <v-list-item-content>
                    <v-list-item-title v-text="'Settings'"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="" to="/logout">
                  <v-list-item-content>
                    <v-list-item-title v-text="'Logout'"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <!-- End Navbar -->
</template>

<!-- SCRIPT -->
<script>
import DomainListDropdown from "./DomainListDropdown.vue";
import NotificationsList from "./NotificationsList.vue";
import NavbarToggleButton from "./NavbarToggleButton";

export default {
  name: "Navbar",
  data: function () {
    return {
      userInfo: this.$store.state.cognitoInfo,
      showProfile: false,
      showSideBar: false,
      toggled: false,
      isMobile: false,
      windowWidth: 0,
    };
  },
  props: {
    type: {
      type: String,
      default: "white",
      description: "Navbar type (e.g default, primary etc)",
    },
    title: {
      type: String,
      default: "",
      description: "Title of navbar",
    },
    contentId: {
      type: [String, Number],
      default: Math.random().toString(),
      description:
        "Explicit id for the menu. By default it's a generated random number",
    },
    effect: {
      type: String,
      default: "dark",
      description: "Effect of the navbar (light|dark)",
    },
    round: {
      type: Boolean,
      default: false,
      description: "Whether nav has rounded corners",
    },
    transparent: {
      type: Boolean,
      default: true,
      description: "Whether navbar is transparent",
    },
    expand: {
      type: Boolean,
      default: true,
      description: "Whether navbar should contain `navbar-expand-lg` class",
    },
  },
  methods: {
    toggleSidebar: function () {
      this.showSideBar = !this.showSideBar;
      this.$emit("toggle_sidebar", this.showSideBar);
    },
    closeMenu() {
      this.toggled = false;
    },
    checkIfMobile(event) {
      let screenWidth = screen.width;
      // 992 is the width set for d-lg resolutions
      if (screenWidth < 992) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
  },
  computed: {},
  mounted() {
    this.$nextTick(function () {
      window.addEventListener("resize", this.checkIfMobile);
      this.checkIfMobile();
    });
  },
  components: {
    DomainListDropdown,
    NotificationsList,
    NavbarToggleButton,
  },
};
</script>

<!-- Style -->
<style>
</style>